import type { StateCreator } from 'zustand';
import type { AiStatsOverview } from '../types';
import { aiStatsApi } from '../services/aiStatsApi';

export interface AiStatsSlice {
  aiStats: AiStatsOverview | null;
  aiStatsLoading: boolean;
  aiStatsDays: number;
  fetchAiStats: (days?: number) => Promise<void>;
}

export const createAiStatsSlice: StateCreator<AiStatsSlice> = (set, get) => ({
  aiStats: null,
  aiStatsLoading: false,
  aiStatsDays: 7,

  fetchAiStats: async (days) => {
    const d = days ?? get().aiStatsDays;
    set({ aiStatsLoading: true, aiStatsDays: d });
    try {
      const data = await aiStatsApi.get(d);
      set({ aiStats: data, aiStatsLoading: false });
    } catch {
      set({ aiStatsLoading: false });
    }
  },
});
